//https://github.com/zloirock/core-js#installation
// import 'core-js';
// import 'regenerator-runtime/runtime';
// import 'es6-promise/auto'
import axios from "axios";
import "./bootstrap";
import "./vendor/bala.DualSelectList.jquery";
import Vue from "vue";
import VueAuth from "@websanova/vue-auth";
import VueAxios from "vue-axios";
import VueRouter from "vue-router";
import auth from "./config/auth";
import router from "./config/router";
import VeeValidate, { Validator } from "vee-validate";
import moment from "moment";
import "vue2-datepicker/index.css";
import 'bootstrap-select';

import App from "./App.vue";
import FeedbackContainer from "./components/FeedbackContainer.vue";

import "./config/filters";

// https://github.com/laravel-mix/laravel-mix/issues/2376
// import page here to avoid webpack build issues - hack
import Login from "./pages/Login";
import {isNullOrUndef} from "chart.js/helpers";


// let urlSplit = window.location.href.split('&');
// if(urlSplit.includes('page=studentassignment')) {
//     window.localStorage.clear();
// }

// Set Vue globally
window.Vue = Vue;

// Set up vue event bag
window.events = new Vue();

// allow the UserFeedback to be used
window.feedback = function (message, level = "success", long = false) {
    window.events.$emit("feedback", { message, level, long });
};

// Setup vee-validate
const dict = {
    en: {
        attributes: {
            f_name: "first name",
            l_name: "last name",
            e_mail: "email",
            frm: "frame",
            cellphone: "cell phone",
            h_phone: "home phone",
            flm_ord_no: "film number",
            pose: "pose (crop)",
            sit: "sit number",
            batch: "slate number",
            name: "student name",
            studentnum: "student number",
            studentnum2: "student number 2",
            transid: "transaction ID",
            ord_no: "order number",
            con_no: "contract number",
            schnum: "school id",
            cam_id: "camera id",
            amountpaid: "amount",
            mail_addr1: "mailing address ",
            mail_addr2: "mailing address 2",
            mail_city: "mailing city",
            mail_state: "mailing state",
            mail_zip: "mailing zip code",
            zip: "zip code",
            recpt_no: "receipt number",
            recpt_no2: "receipt number 2",
            pe_email: "parent email",
            logo: "personalization",
            username: "username",
            old_password: "current password",
            new_password: "new password",
            password_confirmation: "password confirmation",
            emp_no: "employee number",
            acc_code: "access code",
        },
    },
};

let MINOR_WORDS = [
    "A",
    "Abaft",
    "About",
    "Above",
    "Afore",
    "After",
    "Along",
    "Amid",
    "Among",
    "An",
    "And",
    "Am",
    "Apud",
    "Are",
    "As",
    "Aside",
    "At",
    "Atop",
    "Below",
    "But",
    "By",
    "Circa",
    "Down",
    "For",
    "From",
    "Given",
    "In",
    "Into",
    "Is",
    "Lest",
    "Like",
    "Mid",
    "Midst",
    "Minus",
    "Near",
    "Next",
    "Nor",
    "Of",
    "Off",
    "On",
    "Onto",
    "Or",
    "Out",
    "Over",
    "Pace",
    "Past",
    "Per",
    "Plus",
    "Pro",
    "Qua",
    "Round",
    "Sans",
    "Save",
    "Since",
    "So",
    "Than",
    "The",
    "Thru",
    "Till",
    "Times",
    "To",
    "Under",
    "Until",
    "Unto",
    "Up",
    "Upon",
    "Via",
    "Vice",
    "With",
    "Worth",
    "Yet",
];

/**
 * Certain words such as initialisms or acronyms should be left uppercase.
 */
let ACRONYMS = ["Id", "Tv", "Html", "Xml", "Url", "Http", "Vpn"];

Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
};

Vue.use(VeeValidate, {
    aria: false,
    errorBagName: "veeErrors",
    fieldsBagName: "veeFields",
    events: "blur",
    dictionary: dict,
});

// Set Vue router
Vue.router = router;
// Vue.router.beforeEach(function (to, from, next) {
//     // TODO: Add route guards here
//     next();
// });
Vue.use(VueRouter);

// Set Vue authentication
Vue.use(VueAxios, axios);
Vue.use(VueAuth, auth);
axios.defaults.baseURL = `${process.env.MIX_APP_URL}/api`;


// Create cancelToken, then add it to all request, so I can cancel all ongoing requests when the logout event is emitted.
window.cancelTokenSource = axios.CancelToken.source();
axios.interceptors.request.use(request => {
    request.cancelToken = window.cancelTokenSource.token;
    return request;
});


// Intercept the axios response and check if it is a 401
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (
            error["response"] &&
            error["response"] != undefined &&
            error["response"].status === 401
        ) {
            Vue.router.push({ path: "/login" });
            if (error.response.data.message === "Token has expired") {
                $(".modal-backdrop").remove();
                $(".body").removeClass("modal-open");
                feedback(
                    "Your session has expired, please log in again",
                    "danger"
                );
            } else {
                if (error.response.data.message !== "unverified")
                    feedback(error.response.data.message, "danger");
            }
        } else if (
            error["response"] &&
            error["response"] != undefined &&
            error["response"].status === 403
        ) {
            Vue.router.push({ path: "/dashboard" });
        }

        return Promise.reject(error);
    }
);

// Load Components
Vue.component("feedback", FeedbackContainer);
Vue.component("app", App);

Vue.mixin({
    methods: {
        getAppSchool() {
            if (sessionStorage.getItem("schoolSelected")) {
                return JSON.parse(sessionStorage.getItem("schoolSelected"));
            } else if (localStorage.getItem("schoolSelected")) {
                return JSON.parse(localStorage.getItem("schoolSelected"));
            }
            return null;
        },

        getAppContract() {
            if (sessionStorage.getItem("contractSelected")) {
                return JSON.parse(sessionStorage.getItem("contractSelected"));
            } else if (localStorage.getItem("contractSelected")) {
                return JSON.parse(localStorage.getItem("contractSelected"));
            }
            return null;
        },

        delayCallback: function (callback, ms) {
            let timer = 0;
            return function () {
                let context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },

        copyObject(object) {
            return JSON.parse(JSON.stringify(object));
        },

        ellipses(str, len) {
            return str && str.length > len
                ? str.substring(0, len - 3) + " ..."
                : str;
        },

        formatNumber: function (
            amount,
            decimalCount = 2,
            decimal = ".",
            thousands = ","
        ) {
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(
                    (amount = Math.abs(Number(amount) || 0).toFixed(
                        decimalCount
                    ))
                ).toString();
                let j = i.length > 3 ? i.length % 3 : 0;

                let n =
                    (j ? i.substr(0, j) + thousands : "") +
                    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
                    (decimalCount
                        ? decimal +
                          Math.abs(amount - i)
                              .toFixed(decimalCount)
                              .slice(2)
                        : "");
                return negativeSign + n;
            } catch (e) {
                console.error("Error formatting number: ", e);
            }
        },

        formatDateTime(date = null, format = null, newFormat = null) {
            if (isNullOrUndef(format)) {
                format = "YYYY-MM-DD hh:mm:ss";
            }

            if (isNullOrUndef(newFormat)) {
                newFormat = "LLLL";
            }

            return moment(date, format).format(newFormat);
        },

        formatDateLong(date = null) {
            var format = "YYYY-MM-DD hh:mm:ss";
            return moment(date, format).format("dddd, MMMM D, YYYY");
        },

        formatTime(date = null) {
            const options = { hour: "2-digit", minute: "2-digit" };
            let d = new Date();
            if (date) d = new Date(date);

            return d.toLocaleTimeString("en-US", options);
        },

        formatDtTm(date, format="MM/DD/YY") {
            return date ? moment(date).format(format) : null;
        },

        pageOffset(el) {
            var rect = el.getBoundingClientRect(),
                scrollLeft =
                    window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop =
                    window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
        },

        permissionCheck(permission = null) {
            if (
                permission !== null &&
                this.$auth.user().roles.includes("System Admin")
            ) {
                return true;
            } else
                return !!(permission !== null && this.$auth.user().permissions.includes(permission));
        },

        checkRoutePermission(action, route = null) {
            if (!route) {
                route = this.$route.name; // Current route
            }
            return action && this.$auth.user().routePermissions && this.$auth.user().routePermissions.includes(route + ':' + action);
        },

        plural(word, count = 0, inclusive = false) {
            if (!word || typeof word !== "string") return "";
            return word + (count == 1 ? "" : "s");
        },

        /**
         *
         * Parse all numbers out of a string
         */
        numbersInString(str) {
            if (str && str.constructor == String && str.match(/\d+/gi)) {
                return parseInt(str.match(/\d+/gi).join(""));
            }
            return null;
        },

        titleCase(value) {
            if (value === undefined || value === null) return "";

            //  make each word capitalize
            var str = value.toString();
            str = str.replace(/([^\W_]+[^\s-]*) */g, function (s) {
                return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
            });

            //  Certain minor words should be left lowercase unless they are the first or last words in the string.
            var i, j, regexp;
            for (i = 0, j = MINOR_WORDS.length; i < j; i++) {
                regexp = new RegExp("\\s" + MINOR_WORDS[i] + "\\s", "g");
                str = str.replace(regexp, function (s) {
                    return s.toLowerCase();
                });
            }

            //  Certain words such as initialisms or acronyms should be left uppercase.
            for (i = 0, j = ACRONYMS.length; i < j; i++) {
                regexp = new RegExp("\\b" + ACRONYMS[i] + "\\b", "g");
                str = str.replace(regexp, ACRONYMS[i].toUpperCase());
            }

            return str;
        },
        /*
            SAVING B64 TO FILE
            b64Type: Example: 'application/pdf'
        */
        async saveFile(b64, filename, b64Type) {
            // if IE
            if (navigator.msSaveBlob) {
                let blob = this.b64toBlob(b64, b64Type);
                window.navigator.msSaveOrOpenBlob(blob, filename);
                return;
            }
            // modern browsers
            let anchor = document.createElement("a");
            anchor.href = b64;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        },
        b64toBlob(dataURI, b64Type) {
            var byteString = atob(dataURI.split(",")[1]);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);

            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: b64Type });
        },
        teamColor(teamCode, theme = 'light') {
            const colors = {
                light: {
                    'BL': '#90E7FF',
                    'PU': '#CFBCFF',
                    'GN': '#88FFBE',
                    'YE': '#FFEC77',
                    'OR': '#F9BD7D',
                },
                dark: {
                    'BL': '#005D8F',
                    'PU': '#7F72AF',
                    'GN': '#1E7F5B',
                    'YE': '#DABC12',
                    'OR': '#B55900',
                },
            };

            return  colors[theme][teamCode] || '';
        },
        prettyPhone(phone) {
            if (!phone) return '';
            return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
    },
});

const application = new Vue({
    mixins: [
        "formatNumber",
        "formatDateTime",
        "formatTime",
        "permissionCheck",
        "plural",
    ],
    el: "#vue-app",
    router,
});
